import Page from 'flarum/components/Page';
import parseValidationError from '../utils/parseValidationError';

/* global m */

export default class AbstractProcessingPage extends Page {
    init() {
        super.init();

        this.errorPage = null;
        this.dirty = false;
        this.loading = false;
        this.savedAt = null;
        this.validationErrors = {};
    }

    pageLoadErrorHandler(error) {
        switch (error.status) {
            case 401:
            case 403:
                this.errorPage = 'denied';
                break;
            case 404:
            case 410:
                this.errorPage = 'notfound';
                break;
            default:
                throw error;
        }

        m.redraw();
    }

    onerror(error) {
        this.loading = false;

        let wasHandled = false;

        if (error.status === 422 && error.response.errors) {
            wasHandled = true;

            this.validationErrors = parseValidationError(error);
        }

        m.redraw();

        if (!wasHandled) {
            throw error;
        }
    }
}
